export const segmentFeatureKey = "SEGMENT";
